<template>
<div style="padding: 32px 15px" class="starter-main mycontainer">
    <!-- <HeaderPage :title="header.title" :list="header.list" :image="header.image" :tipe_gambar="header.tipe" /> -->

    <div class="row">
      <div class="col-12">
        <DistributionMap ></DistributionMap>
      </div>
      <div class="col-sm-12">
        <Network :last_update="last_update.distribution_map" :data="network"></Network>
      </div>
      <div class="col-sm-8">
        <Budget :last_update="last_update.budget" :data="budget"></Budget>
      </div>
      <div class="col-sm-4">
        <AssetEvaluation :last_update="last_update.asset_evaluation" :data="asset_evaluation"></AssetEvaluation>
      </div>
      <div class="col-sm-12">
        <WorkOrderMonitoring :last_update="last_update.work_order_monitoring" :data="work_order_monitoring"></WorkOrderMonitoring>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPage from "@/components/HeaderPage.vue";
import DistributionMap from "../cards/DistributionMap.vue";
import Network from "../cards/Network.vue";
import Budget from "../cards/Budget.vue";
import AssetEvaluation from "../cards/AssetEvaluation.vue";
import WorkOrderMonitoring from "../cards/WorkOrderMonitoring.vue";

import DistributionService from "@/services/distribution/distribution";
const apiDistribution = DistributionService.build();

export default {
  components: {
    HeaderPage,
    DistributionMap,
    Network,
    Budget,
    AssetEvaluation,
    WorkOrderMonitoring
  },
  created() {
    this.$store.commit("updateJudulHalaman", "");
  },
  data() {
    return {
      //notification bar
      header: {
        title:
          "Overall stable and positive figures on Distribution KPIs, with increase in Distribution Losses (susut) compared to last year due to weather issues in eastern area of Indonesia (Maluku, Papua, dan Nusa Tenggara)",
        list: [],
        image: require('@/assets/images/logo/image_kanan3.png'),
        tipe: 'color-burn'
      },

      last_update: {
        netowork: "1 Day Ago",
        budget: "6 Hours Ago",
        asset_evaluation: "3 Minutes Ago",
        work_order_monitoring: "9 Minutes Ago",
      },

      network: [],
      network_detail: [],

      budget: [],
      budget_detail: [],

      work_order: [],
      work_order_detail_region: [],
      work_order_detail_uid: [],
      work_order_detail_up3: [],

      asset_evaluation: [],
      
    };
  },

  methods: {

    

    async getDataDistributionWorkOrder(directorate) {
      let param = Object.assign({
        directorate: directorate
      });
      const res = await apiDistribution.getDataDistributionWorkOrder(param);
      if (res && res.status == 200) {
        this.work_order = res.data.data;
      }
    },

    async getDataDistributionWorkOrderDetailRegion(params) {
      let param = Object.assign({
        id: params.id,
      });
      const res = await apiDistribution.getDataDistributionWorkOrderDetailRegion(param);
      if (res && res.status == 200) {
        this.work_order_detail_region = res.data.data;
      }
    },

    async getDataDistributionWorkOrderDetailUid(params) {
      let param = Object.assign({
        id: params.id,
      });
      const res = await apiDistribution.getDataDistributionWorkOrderDetailUid(param);
      if (res && res.status == 200) {
        this.work_order_detail_uid = res.data.data;
      }
    },

    async getDataDistributionWorkOrderDetailUp3(params) {
      let param = Object.assign({ 
        id: params.id,
      });
      const res = await apiDistribution.getDataDistributionWorkOrderDetailUp3(param);
      if (res && res.status == 200) {
        this.work_order_detail_up3 = res.data.data;
      }
    },

  }
};
</script>

<style scoped>

</style>
